<!-- =========================================================================================
	File Name: DataListListView.vue
	Description: Data List - List View
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vs-prompt
      title="Search"
      @cancel="val = ''"
      @accept="searchQuery"
      @close="searchPrompt = false"
      :active.sync="searchPrompt"
    >
      <div class="con-exemple-prompt">
        <h4 class="mt-6 mb-2 block">Filters</h4>

        <vs-input
          label="Search by Ticket Purchase Invoice#"
          placeholder="Invoice#"
          v-model="searchFilters.invoice"
          class="mt-3 w-full"
        />
        <div class="mt-4" v-if="currentTab == 0">
          <vs-select
            class="mt-4"
            style="min-width: 300px"
            label="Search and Enter Project Name."
            placeholder="Select Project"
            v-model="searchFilters.project"
            ><vs-select-item
              :key="data.id"
              :value="data.uid"
              :text="data.name"
              v-for="data in projects"
            />
          </vs-select>
        </div>

        <template v-if="currentTab == 111">
          <span class="mt-4 block">Product Specific</span>
          <vSelect v-model="searchFilters.product" :options="productList" />
        </template>

        <span class="mt-4 block"
          >Start Date
          <span v-if="searchFilters.dateFrom.getTime"
            >—
            <a @click.prevent="searchFilters.dateFrom = ''" href="#"
              >clear</a
            ></span
          ></span
        >
        <!-- <datepicker v-model="searchFilters.dateFrom" placeholder="Select Start Date" /> -->
        <input
          type="date"
          v-model="searchFilters.dateFrom"
          class="form-control flatpickr-input w-full"
        />

        <span class="mt-4 block"
          >End Date
          <span v-if="searchFilters.dateTo.getTime"
            >—
            <a @click.prevent="searchFilters.dateTo = ''" href="#"
              >clear</a
            ></span
          ></span
        >
        <!-- <datepicker v-model="searchFilters.dateTo" placeholder="Select Start Date" /> -->
        <input
          type="date"
          v-model="searchFilters.dateTo"
          class="form-control flatpickr-input w-full"
        />

        <p class="text-danger" v-if="dateError">
          There is an error with the date choices. Please review
        </p>
      </div>
    </vs-prompt>

    <vs-tabs v-model="currentTab">
      <vs-tab label="Tickets Used">
        <div
          class="flex justify-between py-3 px-4 rounded text-sm my-4"
          style="background: #eee"
          v-if="searchUrl.url.length > 2"
        >
          <span>
            <span class="py-1 px-2 text-white" style="background: #aaa"
              >Found {{ totalTransactionsQueried }} Records
            </span>
            <span class="inline-block ml-2" v-if="searchedTerm.account"
              >By Account: <b>"{{ searchedTerm.account }}"</b></span
            >
            <span class="inline-block ml-2" v-if="searchedTerm.invoice"
              >Invoice# Containing: <b>"{{ searchedTerm.invoice }}"</b></span
            >
            <span class="inline-block ml-2" v-if="searchedTerm.product"
              >By Product: <b>"{{ searchedTerm.product }}"</b></span
            >
            <span class="inline-block ml-2" v-if="searchedTerm.dateFrom"
              >Starting Date: <b>"{{ searchedTerm.dateFrom }}"</b></span
            >
            <span class="inline-block ml-2" v-if="searchedTerm.dateTo"
              >End Date: <b>"{{ searchedTerm.dateTo }}"</b></span
            >
          </span>
          <vs-button size="small" color="warning" @click.native="clearSearch"
            >Clear Filter</vs-button
          >
        </div>
        <div class="flex justify-between my-4 items-end" v-else>
          <div class="order-2">
            Found {{ totalTransactionsQueried }} Record(s)
          </div>
          <div
            class="p-3 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-warning border border-solid border-warning"
            @click="searchModal"
          >
            <feather-icon icon="SearchIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base">Filter Tickets Used</span>
          </div>
        </div>
        <vs-table :data="transactionsQueried">
          <template slot="thead">
            <vs-th>Date</vs-th>
            <vs-th>Time</vs-th>
            <vs-th>Invoice#</vs-th>
            <!-- <vs-th>Project</vs-th> -->
            <vs-th>Truck</vs-th>
            <vs-th>Product</vs-th>
            <vs-th>Manifest#</vs-th>
            <vs-th>Manifest Detail</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="tr.username">
                {{ getDate(tr.updatedAt) }}
              </vs-td>
              <vs-td :data="tr">
                {{ getTime(tr.updatedAt) }}
              </vs-td>
              <vs-td :data="tr.ticketOrder">
                {{ tr.ticketOrder.uid }}
              </vs-td>
              <!-- <vs-td :data="tr">
                <div v-if="tr.projects[0]">{{ tr.projects[0].name }}</div>
                <div v-else>{{ "N/A" }}</div>
              </vs-td> -->
              <vs-td>
                {{ (tr && tr.truck && tr.truck.licPlate) || "N/A" }}
              </vs-td>
              <vs-td :data="tr">
                {{ tr.product.title }}
              </vs-td>

              <vs-td :data="tr">
                {{ tr.uid || "N/A" }}
              </vs-td>
              <vs-td :data="tr">
                <a
                  :href="`https://api.resoilsolutions.com/pdf/transaction/${tr.id}`"
                  target="_blank"
                  class="text-black underline"
                  >PDF</a
                >
              </vs-td>

              <template class="expand-user" slot="expand">
                <div class="con-expand-users w-full">
                  <div
                    class="pl-2 md:pl-5 flex flex-col gap-1ch"
                    style="margin: 1ch"
                  >
                    <div
                      class="con-userx flex items-center justify-start gap-1ch"
                    >
                      <strong>Account:</strong>
                      <a
                        @click.prevent="
                          $router.push(`/account/${tr.account.id}`)
                        "
                        href="#"
                        >{{ tr.account.name }}</a
                      >
                    </div>
                    <div
                      class="con-userx flex items-center justify-start gap-1ch"
                      v-if="tr.projects[0]"
                    >
                      <strong>Projects:</strong>
                      <span
                        v-for="(project, index) in tr.projects"
                        :key="index"
                        >{{ project.name }},</span
                      >
                    </div>
                    <div
                      class="con-userx flex items-center justify-start gap-1ch"
                      v-if="tr.truck"
                    >
                      <strong>Truck:</strong>
                      <span>{{ tr.truck.name }}</span>
                    </div>
                    <div
                      class="con-userx flex items-center justify-start gap-1ch"
                      v-if="tr.driver"
                    >
                      <strong>Driver:</strong>
                      <span
                        >{{ tr.driver.firstName }}
                        {{ tr.driver.lastName }}</span
                      >
                    </div>
                    <div
                      class="con-userx flex items-center justify-start gap-1ch"
                      v-if="tr.scanner && tr.scanner.email"
                    >
                      <strong>Scanner:</strong>
                      <span>{{ tr.scanner.email }}</span>
                    </div>
                    <div
                      class="con-userx items-center justify-start gap-1ch"
                      v-if="tr.manifest && tr.manifest.length"
                    >
                      <strong>Manifest</strong>
                      <div
                        v-for="(itm, idx) in tr.manifest.filter(
                          (x) => x.date && x.location
                        )"
                        :key="idx + 's'"
                      >
                        <span
                          >#{{ idx + 1 }}.
                          <strong>{{ itm.date }}</strong> @<strong>{{
                            itm.location
                          }}</strong>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </vs-tr>
          </template>
        </vs-table>
        <div class="flex justify-between mt-4">
          <vs-pagination
            class="mt-3"
            :total="trMax"
            v-model="trPage"
          ></vs-pagination>
          <div class="block mt-3">
            <span v-if="!searchUrl.url" class="btn text-sm"
              >Please Filter to See Export Options</span
            >
            <vs-button
              color="gray"
              @click="downloadCSV"
              class="tab-btn ml-4"
              v-if="searchUrl.url"
              >Export For Excel (CSV)
              <span v-if="searchUrl.url.length">(Filtered)</span></vs-button
            >
          </div>
        </div>
      </vs-tab>

      <vs-tab label="Tickets Purchased">
        <div
          class="flex justify-between py-3 px-4 rounded text-sm my-4"
          style="background: #eee"
          v-if="searchUrl.url.length > 2"
        >
          <span>
            <span class="py-1 px-2 text-white" style="background: #aaa"
              >Found {{ totalFundsQueried }} Records
            </span>
            <span class="inline-block ml-2" v-if="searchedTerm.account"
              >By Account: <b>"{{ searchedTerm.account }}"</b></span
            >
            <span class="inline-block ml-2" v-if="searchedTerm.invoice"
              >Invoice# Containing: <b>"{{ searchedTerm.invoice }}"</b></span
            >
            <span class="inline-block ml-2" v-if="searchedTerm.product"
              >By Product: <b>"{{ searchedTerm.product }}"</b></span
            >
            <span class="inline-block ml-2" v-if="searchedTerm.dateFrom"
              >Starting Date: <b>"{{ searchedTerm.dateFrom }}"</b></span
            >
            <span class="inline-block ml-2" v-if="searchedTerm.dateTo"
              >End Date: <b>"{{ searchedTerm.dateTo }}"</b></span
            >
          </span>
          <vs-button size="small" color="warning" @click.native="clearSearch"
            >Clear Filter</vs-button
          >
        </div>
        <div v-else class="flex justify-between my-4 items-end">
          <div class="order-2">Found {{ totalFundsQueried }} Record(s)</div>
          <div
            class="p-3 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-warning border border-solid border-warning"
            @click="searchModal"
          >
            <feather-icon icon="SearchIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base">Filter Tickets Purchased</span>
          </div>
          <div class="flex justify-end" style="gap: 1ch" v-if="false">
            <label
              :class="{
                'font-bold': incompleteFunds,
                'text-danger': incompleteFunds,
              }"
              >Showing {{ incompleteFunds ? "only incomplete" : "All" }}
            </label>
            <vs-switch color="danger" v-model="incompleteFunds" />
          </div>
        </div>

        <vs-table :data="fundsQueried">
          <template slot="thead">
            <vs-th>Invoice Date</vs-th>
            <vs-th>Invoice #</vs-th>
            <vs-th>Sub Total ($)</vs-th>
            <vs-th>Total ($)</vs-th>
            <vs-th>Discount</vs-th>
            <vs-th>Payment Type</vs-th>
            <vs-th>Doc</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                {{ getDate(tr.createdAt) }}
              </vs-td>
              <vs-td>
                {{ tr.uid }}
              </vs-td>
              <vs-td>
                {{ formatPrice(tr.subTotal) }}
              </vs-td>
              <vs-td>
                {{ formatPrice(tr.total) }}
              </vs-td>
              <vs-td>
                {{ formatPrice(tr.discount || 0 ) }}
              </vs-td>

              <vs-td>
                <span
                  class="uppercase"
                  :class="tr.status === 'complete' ? '' : 'text-danger'"
                >
                  {{ tr.type }}
                </span>
              </vs-td>

              <vs-td :data="tr">
                <a
                  class="text-black underline"
                  :href="`https://api.resoilsolutions.com/pdf/invoice/${tr.id}`"
                  target="_blank"
                  >PDF</a
                >
              </vs-td>

              <template class="expand-user" slot="expand">
                <div class="con-expand-users w-full">
                  <div
                    class="pl-2 md:pl-5 flex flex-col gap-1ch"
                    style="margin: 1ch"
                  >
                    <vs-table :data="tr.orderItems">
                      <template slot="thead">
                        <vs-th>Product</vs-th>
                        <vs-th>Qty</vs-th>
                        <vs-th>Unit Price</vs-th>
                        <!-- <vs-th>Subtotal</vs-th> -->
                 
                      </template>

                      <template slot-scope="{ data }">
                        <vs-tr
                          :data="pr"
                          :key="indexpr"
                          v-for="(pr, indexpr) in data"
                        >
                          <vs-td>
                            {{ pr.product.title }}
                          </vs-td>
                          <vs-td>
                            {{ pr.quantity }}
                          </vs-td>
                          <vs-td>
                            {{ formatPrice(pr.price) }}
                          </vs-td>
                          <!-- <vs-td>
                            {{ formatPrice(pr.price * pr.quantity) }}
                          </vs-td> -->
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
                </div>
              </template>
            </vs-tr>
          </template>
        </vs-table>

        <div class="flex justify-between mt-4">
          <vs-pagination
            class="mt-3"
            :total="fundsMax"
            v-model="fundPage"
          ></vs-pagination>
          <div class="block mt-3">
            <span v-if="!searchUrl.url" class="btn text-sm"
              >Please Filter to See Export Options</span
            >
            <vs-button
              color="gray"
              @click="downloadCSV"
              class="tab-btn ml-4"
              v-if="searchUrl.url"
              >Export For Excel (CSV)
              <span v-if="searchUrl.url.length">(Filtered)</span></vs-button
            >
          </div>
        </div>
      </vs-tab>

      <vs-tab label="Tickets Paid">
        <div
          class="flex justify-between items-center py-3 px-4 rounded text-sm my-4"
          style="background: #eee; border-radius: 5px"
          v-if="searchUrl.url.length > 2"
        >
          <span>
            <span class="py-1 px-2 text-white" style="background: #aaa"
              >Found {{ totalPaymentsQueried }} Records
            </span>
            <span class="inline-block ml-2" v-if="searchedTerm.account"
              >By Account: <b>"{{ searchedTerm.account }}"</b></span
            >
            <span class="inline-block ml-2" v-if="searchedTerm.invoice"
              >Invoice# Containing: <b>"{{ searchedTerm.invoice }}"</b></span
            >
            <span class="inline-block ml-2" v-if="searchedTerm.product"
              >By Product: <b>"{{ searchedTerm.product }}"</b></span
            >
            <span class="inline-block ml-2" v-if="searchedTerm.dateFrom"
              >Starting Date: <b>"{{ searchedTerm.dateFrom }}"</b></span
            >
            <span class="inline-block ml-2" v-if="searchedTerm.dateTo"
              >End Date: <b>"{{ searchedTerm.dateTo }}"</b></span
            >
          </span>
          <vs-button size="small" color="warning" @click.native="clearSearch"
            >Clear Filter</vs-button
          >
        </div>
        <div v-else class="flex justify-between my-4 items-end">
          <div class="order-2">Found {{ totalPaymentsQueried }} Record(s)</div>
          <div
            class="p-3 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-warning border border-solid border-warning"
            @click="searchModal"
          >
            <feather-icon icon="SearchIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base">Filter Payments</span>
          </div>
        </div>
        <vs-table :data="paymentsQueried">
          <template slot="thead">
            <vs-th>Payment Date</vs-th>
            <vs-th>Invoice No.</vs-th>
            <vs-th>Total</vs-th>
            <vs-th>Paid</vs-th>
            <vs-th>Discount</vs-th>
            <vs-th>Type</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                {{ getDate(tr.date) }}
              </vs-td>
              <vs-td>
                {{ tr.ticketOrder.uid }}
              </vs-td>

              <vs-td>
                {{ formatPrice(tr.ticketOrder.total) }}
              </vs-td>
              <vs-td>
                {{ formatPrice(tr.amount) }}
              </vs-td>
              <vs-td>
                {{ formatPrice(tr.ticketOrder.discount || 0 ) }}
              </vs-td>
              <vs-td>
                {{
                  tr.type
                    ? tr.type.toUpperCase()
                    : tr.ticketOrder.type.toUpperCase()
                }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <div class="flex justify-between mt-4">
          <vs-pagination
            class="mt-3"
            :total="paymentsMax"
            v-model="paymentPage"
          ></vs-pagination>
          <div class="block mt-3">
            <span v-if="!searchUrl.url" class="btn text-sm"
              >Please Filter to See Export Options</span
            >
            <vs-button
              color="gray"
              @click="downloadCSV"
              class="tab-btn"
              v-if="searchUrl.url"
              >Export For Excel (CSV)
              <span v-if="searchUrl.url.length">(Filtered)</span></vs-button
            >
          </div>
        </div>
      </vs-tab>

      <vs-tab label="Payments Outstanding">
        <div
          class="flex justify-between py-3 px-4 rounded text-sm my-4"
          style="background: #eee"
          v-if="searchUrl.url.length > 2"
        >
          <span>
            Filtered:
            <span class="inline-block ml-2" v-if="searchedTerm.account"
              >By Account: <b>"{{ searchedTerm.account }}"</b></span
            >
            <span class="inline-block ml-2" v-if="searchedTerm.invoice"
              >Invoice# Containing: <b>"{{ searchedTerm.invoice }}"</b></span
            >
            <span class="inline-block ml-2" v-if="searchedTerm.product"
              >By Product: <b>"{{ searchedTerm.product }}"</b></span
            >
            <span class="inline-block ml-2" v-if="searchedTerm.dateFrom"
              >Starting Date: <b>"{{ searchedTerm.dateFrom }}"</b></span
            >
            <span class="inline-block ml-2" v-if="searchedTerm.dateTo"
              >End Date: <b>"{{ searchedTerm.dateTo }}"</b></span
            >
          </span>
          <vs-button size="small" color="warning" @click.native="clearSearch"
            >Clear Filter</vs-button
          >
        </div>
        <div v-else class="flex justify-between my-4 items-end">
          <div class="order-2">
            <!-- Found {{ totalTransactionsQueried }} Record(s) -->
          </div>
          <div
            class="p-3 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-warning border border-solid border-warning"
            @click="searchModal"
          >
            <feather-icon icon="SearchIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base">Filter Unpaid Invoices</span>
          </div>
        </div>

        <vs-table :data="unpaidsQueried">
          <template slot="thead">
            <vs-th>Invoice#</vs-th>
            <vs-th>Total</vs-th>
            <vs-th>Balance to pay</vs-th>
            <vs-th>Doc</vs-th>
            <vs-th>Payments</vs-th>
            <vs-th>Usage</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                {{ tr.uid }}
                <span
                  title="Overdraft Ticket"
                  class="font-semibold"
                  v-if="tr.type === 'overdraft'"
                  >(OD)</span
                >
              </vs-td>
              <vs-td>
                {{ formatPrice(tr.total) }}
              </vs-td>
              <vs-td class="text-danger">
                {{ formatPrice(tr.total - tr.totalPaid) }}
              </vs-td>
              <vs-td :data="tr">
                <a
                  class="text-black underline"
                  :href="`https://api.resoilsolutions.com/pdf/invoice/${tr.id}`"
                  target="_blank"
                  >PDF</a
                >
              </vs-td>
              <vs-td>
                <a
                  href="#"
                  @click.prevent="showPaid(tr.uid)"
                  class="py-2"
                  v-if="tr.payments && tr.payments.length"
                  >Show Payments</a
                >
                <span v-else>--</span>
              </vs-td>
              <vs-td>
                <a
                  href="#"
                  @click.prevent="showUsage(tr.uid)"
                  class="py-2"
                  v-if="tr.ticketsUsed && tr.ticketsUsed.length"
                  >Show Tickets usage</a
                >
              </vs-td>

              <template class="expand-user" slot="expand">
                <div class="con-expand-users w-full">
                  <div
                    class="pl-2 md:pl-5 flex flex-col gap-1ch"
                    style="margin: 1ch"
                  >
                    <vs-table :data="tr.orderItems">
                      <template slot="thead">
                        <vs-th>Product</vs-th>
                        <vs-th>Qty</vs-th>
                        <vs-th>Unit Price</vs-th>
                        <vs-th>Subtotal</vs-th>
                      </template>

                      <template slot-scope="{ data }">
                        <vs-tr
                          :data="pr"
                          :key="indexpr"
                          v-for="(pr, indexpr) in data"
                        >
                          <vs-td>
                            {{ pr.product.title }}
                          </vs-td>
                          <vs-td>
                            {{ pr.quantity }}
                          </vs-td>
                          <vs-td>
                            {{ formatPrice(pr.price) }}
                          </vs-td>
                          <vs-td>
                            {{ formatPrice(pr.price * pr.quantity) }}
                          </vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
                </div>
              </template>
            </vs-tr>
          </template>
        </vs-table>

        <div class="flex justify-between mt-4">
          <vs-pagination
            class="mt-3"
            :total="unpaidsMax"
            v-model="unpaidsPage"
          ></vs-pagination>
          <div class="block mt-3">
            <span v-if="!searchUrl.url" class="btn text-sm"
              >Please Filter to See Export Options</span
            >
            <vs-button
              color="gray"
              @click="downloadCSV"
              class="tab-btn ml-4"
              v-if="searchUrl.url"
              >Export For Excel (CSV)
              <span v-if="searchUrl.url.length">(Filtered)</span></vs-button
            >
          </div>
        </div>
      </vs-tab>
<!-- 
      <vs-tab label="Tickets Outstanding">
        <vs-table :data="unusedQueried">
          <template slot="thead">
            <vs-th>Payment Date</vs-th>
            <vs-th>Ticket Order Number</vs-th>
            <vs-th>Product Type</vs-th>
            <vs-th>Price</vs-th>
            <vs-th>Total Available</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                {{ getDate(tr.date) }}
              </vs-td>
              <vs-td>
                {{ tr.ticketOrder.uid }}
              </vs-td>

              <vs-td>
                {{ formatPrice(tr.ticketOrder.total) }}
              </vs-td>
              <vs-td>
                {{ formatPrice(tr.amount) }}
              </vs-td>
              <vs-td>
                {{
                  tr.type
                    ? tr.type.toUpperCase()
                    : tr.ticketOrder.type.toUpperCase()
                }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vs-tab> -->
    </vs-tabs>
  </div>
</template>

<script>
import DataSidebar from "@/components/DataSidebar.vue";

import {
  getDate,
  getTime,
  $loading,
  formatDate,
  formatPrice,
} from "@/assets/helper";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
export default {
  components: {
    DataSidebar,
    vSelect,
    Datepicker,
  },
  data() {
    return {
      searchResultsTotal: 0,
      allPayments: [],
      model: null,
      accountQuery: "",
      searchPrompt: false,
      termUsed: {
        account: "",
        product: "",
        dateFrom: "",
        dateTo: "",
        url: "",
      },
      termPurchased: {
        account: "",
        product: "",
        dateFrom: "",
        dateTo: "",
        url: "",
      },
      termPaid: {
        account: "",
        product: "",
        dateFrom: "",
        dateTo: "",
        url: "",
      },
      termUnpaids: {
        account: "",
        product: "",
        dateFrom: "",
        dateTo: "",
        url: "",
      },
      results: {
        used: [],
        purchased: [],
        paid: [],
        unpaids: [],
        unused: [],
      },
      searchResults: [],
      searchUsedTotal: 0,
      searchPurchasedTotal: 0,
      searchPaidTotal: 0,
      searchFilters: {
        invoice: "",
        account: "",
        product: "",
        dateFrom: "",
        dateTo: "",

        project: "",

      },
      incompleteFunds: false,
      currentTab: 0,

      transactions: [],
      totalTransactions: 0,
      trPage: 1,

      allFunds: [],
      totalFunds: 0,
      fundPage: 1,

      allUnpaids: [],
      totalUnpaids: 0,
      unpaidsPage: 1,

      totalPayments: 1,
      paymentPage: 1,

      selected: [],
      itemsPerPage: 10,
      isMounted: false,

      totalPurchased: [],

      projects: [],

    };
  },
  mounted() {
    this.isMounted = true;
  },
  watch: {
    async unpaidsApi(val) {
      if (!val) return;
      $loading();
      await this.doUnpaids(val);
      $loading.close();
    },
    "searchUrl.count"(val) {
      if (!val.includes("/count")) return (this.searchResultsTotal = 0);

      this.$get(val).then(({ data }) => {
        this.searchResultsTotal = data;
      });
    },
    "searchUrl.paginated"(val, oldVal) {
      let { url, count, paginated } = this.searchUrl;

      if (!url.length) return;

      $loading();

      this.$get(paginated)
        .then(({ data }) => {
          this.results[this.tabName] = data;
        })
        .finally(() => {
          $loading.close();
        });
    },

    searchPrompt(val) {
      this.searchFilters = {
        account: "",
        product: "",
        dateFrom: "",
        dateTo: "",
        invoice: "",

        project: "",

      };
      this.accountQuery = "";
    },
    incompleteFunds() {
      this.fundPage = 1;
    },
    currentTab(val) {
      if (val === 0) this.trPage = 1;
      else this.fundPage = 1;
    },
    trApi: {
      immediate: true,
      async handler(val) {
        console.log("watchhhhhhhhhhhhhhh");
        if (!val) return;
        $loading();
        await this.doTr(val);
        $loading.close();
      },
    },
    async fundsApi(val) {
      if (!val) return;
      $loading();
      await this.doFunds(val);
      $loading.close();
    },
    async paymentsApi(val) {
      if (!val) return;
      $loading();
      await this.doPayments(val);
      $loading.close();
    },
  },
  computed: {
    unpaids() {
      let lines = [];
      let unpaids = this.allUnpaids;

      unpaids.forEach((x) => {
        let { ticketsReleased = [], payments = [], ...line } = x;

        let paidAmount = 0;
        let lastPayment = null;

        if (!payments) payments = [];

        payments = payments.sort((a, b) => {
          a = new Date(a.date).getTime();
          b = new Date(b.date).getTime();
          if (a > b) return -1;
          return 1;
        });
        if (payments.length) lastPayment = payments[0].date;

        payments.forEach((paid) => {
          paidAmount += paid.amount;
          let paidDate = new Date(paid.date).getTime();
        });
        line.lastPayment = lastPayment;
        line.paidAmount = paidAmount;
        line.paidPerc = (paidAmount / line.total) * 100;

        line.orderItems.forEach((item, itemI) => {
          let releasedArray = ticketsReleased.filter(
            ({ product }) => product === item.product.id
          );
          let released = 0;

          releasedArray.forEach(({ quantity = 0 }) => {
            released += quantity;
          });

          item.released = released;
        });
        line.payments = payments;
        lines.push(line);
      });
      return lines;
    },
    searchedTerm() {
      let where =
        this.currentTab === 0
          ? "Used"
          : this.currentTab === 1
          ? "Purchased"
          : "Paid";

      return this.$data[`term${where}`];
    },
    tabName() {
      let tabNames = ["used", "purchased", "paid", "unpaids"];
      return tabNames[this.currentTab];
    },
    funds() {
      let lines = [];
      let funds = this.allFunds;
      if (this.searchUrl.url.length && this.currentTab == 1)
        funds = this.results["purchased"];

      funds.forEach((x) => {
        let { ticketsReleased = [], payments = [], ...line } = x;

        let paidAmount = 0;
        let lastPayment = null;

        if (!payments) payments = [];

        payments = payments.sort((a, b) => {
          a = new Date(a.date).getTime();
          b = new Date(b.date).getTime();
          if (a > b) return -1;
          return 1;
        });
        if (payments.length) lastPayment = payments[0].date;

        payments.forEach((paid) => {
          paidAmount += paid.amount;
          let paidDate = new Date(paid.date).getTime();
        });
        line.lastPayment = lastPayment;
        line.paidAmount = paidAmount;
        line.balance = line.total - paidAmount;
        line.paidPerc = (paidAmount / line.total) * 100;

        line.orderItems.forEach((item, itemI) => {
          let releasedArray = ticketsReleased.filter(
            ({ product }) => product === item.product.id
          );
          let released = 0;

          releasedArray.forEach(({ quantity = 0 }) => {
            released += quantity;
          });

          item.released = released;
        });
        line.payments = payments;
        lines.push(line);
      });
      return lines;
    },
    payments() {
      return this.allPayments;
    },

    paymentsQueried() {
      if (this.searchUrl.url.length && this.currentTab == 2)
        return this.results["paid"];
      return this.payments;
    },
    fundsQueried() {
      // console.log(this.totalFunds, "purchased")
      console.log(this.funds, "ssssuuuuuu");

      return this.funds;
    },
    unusedQueried() {
      console.log(this.totalPurchased, "puuuurrrchase");
      console.log(this.transactions, "useddddddd");
    },
    transactionsQueried() {
      console.log(this.transactions, "used");
      if (this.searchUrl.url.length && this.currentTab == 0)
        return this.results["used"];
      return this.transactions;
    },
    unpaidsQueried() {
      let results = [];
      if (this.searchUrl.url.length && this.currentTab == 3)
        results = this.results["unpaids"];
      else results = this.unpaids;
      results = results.filter((x) => x.account);
      results.forEach((x) => {
        x.balance = x.total - x.totalPaid;
      });
      return results;
    },

    totalFundsQueried() {
      if (this.searchUrl.url.length && this.currentTab == 1)
        return this.searchResultsTotal;
      return this.totalFunds;
    },

    totalPaymentsQueried() {
      if (this.searchUrl.url.length && this.currentTab == 2)
        return this.searchResultsTotal;
      return this.totalPayments;
    },
    totalTransactionsQueried() {
      if (this.searchUrl.url.length && this.currentTab == 0)
        return this.searchResultsTotal;
      return this.totalTransactions;
    },

    searchUrlBACKUP() {
      let url =
        this.currentTab === 0
          ? this.termUsed.url
          : this.currentTab === 1
          ? this.termPurchased.url
          : this.termPaid.url;
      console.log("SERACH URLRLRLRLLRLRLRLRLRLRRLRLRRLRRL", url);
      if (!url.length)
        return {
          url: "",
          count: "",
          paginated: "",
        };

      let count = url.replace(`accounts/get`, `accounts/get/count`);
      let paginated = url;
      let length = paginated.length;
      if (paginated[length - 1] !== "&") paginated += "&";
      let start =
        this.currentTab == 0
          ? this.limit * (this.trPage - 1)
          : this.currentTab == 1
          ? this.limit * (this.fundPage - 1)
          : this.limit * (this.paymentPage - 1);
      paginated += `_sort=${this.sort}`;
      paginated += `&_start=${start}&_limit=${this.limit}`;

      return {
        url,
        count,
        paginated,
      };
    },
    searchUrl() {
      let terms = [
        this.termUsed.url,
        this.termPurchased.url,
        this.termPaid.url,
        this.termUnpaids.url,
      ];
      let url = terms[this.currentTab];
      console.log("SERACH URLRLRLRLLRLRLRLRLRLRRLRLRRLRRL", url);
      if (!url || !url.length)
        return {
          url: "",
          count: "",
          paginated: "",
        };

      let count = url.replace(`accounts/get`, `accounts/get/count`);
      let download = "";
      let paginated = url;
      let length = paginated.length;
      if (paginated[length - 1] !== "&") paginated += "&";
      let start =
        this.currentTab == 0
          ? this.limit * (this.trPage - 1)
          : this.currentTab == 1
          ? this.limit * (this.fundPage - 1)
          : this.limit * (this.paymentPage - 1);
      paginated += `_sort=${this.sort}`;
      paginated += `&_start=${start}&_limit=${this.limit}`;

      return {
        url,
        count,
        paginated,
        download,
      };
    },
    dateError() {
      if (
        !this.searchFilters.dateFrom.getTime ||
        !this.searchFilters.dateTo.getTime
      )
        return false;

      let from = this.searchFilters.dateFrom;
      let to = this.searchFilters.dateTo;

      if (
        from.toString().includes("Invalid") ||
        to.toString().includes("Invalid")
      )
        return false;

      from = from.getTime();
      to = to.getTime();

      if (from < to) return false;
      return true;
    },
    fundsParams() {
      let params = "";
      if (this.incompleteFunds) params += `&status_ne=complete&`;
      return params;
    },
    paymentsApi() {
      if (this.currentTab != 2) return "";
      let start = this.limit * (this.trPage - 1);
      let params = "";
      if (this.sort) params += `_sort=${this.sort}&`;
      if (this.limit) params += `_start=${start}&_limit=${this.limit}`;
      return `/accounts/get?where=paid&${params}`;
    },
    paymentsMax() {
      let total =
        this.searchUrl.url.includes("where=paid") && this.currentTab == 2
          ? this.searchResultsTotal
          : this.totalPayments;
      let limit = this.limit;
      return Math.ceil(total / limit);
    },
    trApi() {
      console.log("jahsdjhasjkdhajkshdjkkhkjsh");
      if (this.currentTab != 0) return "";
      let start = this.limit * (this.trPage - 1);
      let params = "";
      if (this.sort) params += `_sort=${this.sort}&`;
      if (this.limit) params += `_start=${start}&_limit=${this.limit}`;
      return `/accounts/get?where=used&${params}`;
    },
    fundsApi() {
      if (this.currentTab != 1) return "";
      let start = this.limit * (this.fundPage - 1);
      let params = this.fundsParams;
      if (this.sort) params += `_sort=${this.sort}&`;
      if (this.limit) params += `_start=${start}&_limit=${this.limit}`;
      return `/accounts/get?where=ordered&${params}`;
    },
    totalFundsApi() {
      return ``;
    },
    unpaidsApi() {
      if (this.currentTab != 3) return "";
      let start = this.limit * (this.unpaidsPage - 1);
      let params = "isPaid=0&";
      if (this.sort) params += `_sort=${this.sort}&`;
      if (this.limit) params += `_start=${start}&_limit=${this.limit}`;
      return `/accounts/get?where=unpaids&${params}`;
    },
    fundsMax() {
      let total =
        this.searchUrl.url.includes("where=ordered") && this.currentTab == 1
          ? this.searchResultsTotal
          : this.totalFunds;
      let limit = this.limit;
      return Math.ceil(total / limit);
    },
    unpaidsMax() {
      let total =
        this.searchUrl.url.includes("where=unpaids") && this.currentTab == 3
          ? this.searchResultsTotal
          : this.totalUnpaids;
      let limit = this.limit;
      return Math.ceil(total / limit);
    },
    trMax() {
      let total =
        this.searchUrl.url.includes("where=used") && this.currentTab == 0
          ? this.searchResultsTotal
          : this.totalTransactions;
      let limit = this.limit;
      return Math.ceil(total / limit);
    },
    sort() {
      return this.$route.meta.sort || `updatedAt:DESC`;
    },
    limit() {
      return this.$route.meta.limit || 10;
    },
    productList() {
      let options = Object.values(this.$store.state.products).map((prd) => ({
        label: prd.title,
        value: prd.id,
      }));
      return [{ label: "Any", value: "" }, ...options];
    },

  },
  async created() {
    // await this.doUnused();
    await this.getClientProjects();
  },
  methods: {
    formatPrice,
    getDate,
    async getClientProjects() {
      let { data } = await this.$get("/projects/account");
      this.projects = data;
      console.log(data);
    },
   


    async getAllPurchased() {
      try {
        let { data } = await this.$get("accounts/get/?where=ordered");
        this.totalPurchased = data;
      } catch (error) {}
    },
    downloadCSV() {
      let sendOBJ = {
        type: this.tabName,
        query: {
          ...this.filterQuery,
          _limit: -1,
        },
      };

      // return this.$api.post(`/export/csv`, sendOBJ)
     
      fetch(`${process.env.VUE_APP_API}/export/csv`, {
        method: "POST",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
          Authorization: this.$api.defaults.headers["Authorization"],
        },
        responseType: "blob",
        body: JSON.stringify(sendOBJ),
      })
        .then((response) => response.blob())
        .then((blob) => {
          console.log("BLOBBBB", blob);

          let terms = ["termUsed", "termPurchased", "termPaid", "termUnpaids"];
          let filebases = ["visits", "invoices", "payments", "unpaid-invoices"];
          let filebase = filebases[this.currentTab];

          let filename = filebase;

          let where = terms[this.currentTab];
          let term = this.$data[where];
          if (term) {
            if (term.account && term.account.trim().length)
              filename = `${term.account}-${filebase}`;
            if (term.dateFrom && term.dateFrom.trim().length)
              filename += `-from-${term.dateFrom.replace(/\//g, "_")}`;
            if (term.dateTo && term.dateTo.trim().length)
              filename += `-to-${term.dateTo.replace(/\//g, "_")}`;
            if (term.invoice && term.dateTo.trim().length)
              filename += `-to-${term.dateTo.replace(/\//g, "_")}`;
          }

          filename += `.csv`;

          var a = window.document.createElement("a");
          a.href = window.URL.createObjectURL(blob, {
            type: "text/csv",
          });
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        });
    },
    showPaid(uid) {
      let filter = {
        invoice: uid,
        account: "",
        product: "",
        dateFrom: "",
        dateTo: "",
      };
      this.searchQuery(filter, 2);
    },
    showUsage(uid) {
      let filter = {
        invoice: uid,
        account: "",
        product: "",
        dateFrom: "",
        dateTo: "",

        project: "",

      };
      this.searchQuery(filter, 0);
    },
    listProducts(tr) {
      console.log("TRRRRRRRRRRR", tr);
      if (tr.orderItems.length === 1) return tr.orderItems[0].product.title;
      let rest = tr.orderItems.length - 1;
      return `${tr.orderItems[0].product.title}, + ${rest}`;
    },
    clearSearch() {
      this.searchResults = [];
      let terms = ["termUsed", "termPurchased", "termPaid", "termUnpaids"];
      let where = terms[this.currentTab];

      this.$data[where] = {
        account: "",
        product: "",
        dateFrom: "",
        dateTo: "",
        url: "",
      };
      this.trPage = 1;
      this.fundPage = 1;
      this.unpaidsPage = 1;
      this.paymentPage = 1;
    },
    searchModal() {
      this.searchPrompt = true;
      this.trPage = 1;
      this.fundPage = 1;
      this.paymentPage = 1;
      this.unpaidsPage = 1;
    },
    searchQueryBACKUP(filters, tab = this.currentTab) {
      if (this.dateError) return;
      if (!filters) filters = this.searchFilters;
      let { dateFrom, dateTo, account, product, invoice } = filters;

      if (!dateFrom && !dateTo && !account && !product && !invoice) {
        console.log("CLOSING");
        return (this.searchPrompt = false);
      }

      let accountName = (account && account.name) || "";
      let productName = (product && product.label) || "";

      let baseUrl =
        tab === 0
          ? `/accounts/get?where=used&`
          : tab === 1
          ? `/accounts/get?where=ordered&`
          : "/accounts/get?where=paid&";
      let w = 0;
      let query = "";

      if (product && product.value) {
        let id = product.value;
        query += `_where[${w}][product.id]=${id}&`;
        w++;
      }

      if (account && account.id) {
        let id = account.id;
        query += `_where[${w}][account.id]=${id}&`;
        w++;
      }

      if (invoice.trim()) {
        let wh = "ticketOrder.uid_contains";
        if (tab === 1) wh = "uid_contains";
        query += `_where[${w}][${wh}]=${invoice}&`;
        w++;
      }

      let dayFrom = "";
      let dayTo = "";

      if (dateFrom) {
        dayFrom = formatDate(dateFrom.getTime());
        let date = new Date(dayFrom);
        date = date.toISOString();
        let wh = "createdAt_gte";
        if (tab === 2) wh = "date_gte";
        query += `_where[${w}][${wh}]=${date}&`;
        w++;
      }

      if (dateTo) {
        dayTo = formatDate(dateTo.getTime());
        let date = new Date(dayTo);
        date = date.toISOString();
        let wh = "createdAt_lte";
        if (tab === 2) wh = "date_lte";
        query += `_where[${w}][${wh}]=${date}&`;
        w++;
      }

      let url = baseUrl + query;

      if (dateTo) dateTo = formatDate(dateTo.getTime());

      if (dateFrom) {
        console.log("DATEFROM", dateFrom);
        dateFrom = formatDate(dateFrom.getTime());
        console.log("DATEFROM", dateFrom);
      }

      let where = "termUsed";
      if (tab == 1) where = "termPurchased";
      if (tab == 2) where = "termPaid";

      this.$data[where] = JSON.parse(
        JSON.stringify({
          account: accountName,
          dateTo: dayTo,
          dateFrom: dayFrom,
          product: productName,
          invoice,
          url,
        })
      );

      this.searchPrompt = false;
      if (+this.currentTab !== +tab) this.currentTab = +tab;
    },
    searchQuery(filters, tab = this.currentTab) {
      console.log("SERACH QUERY", filters);
      if (this.dateError) return;
      if (!filters) filters = this.searchFilters;

      let { dateFrom, dateTo, account, product, invoice, project } = filters;

      if (dateFrom && typeof dateFrom === "string") {
        dateFrom += ` 12:00:00`;
        dateFrom = new Date(dateFrom);
      }

      if (dateTo && typeof dateTo === "string") {
        dateTo += ` 12:00:00`;
        dateTo = new Date(dateTo);
      }

      if (
        !dateFrom &&
        !dateTo &&
        !account &&
        !product &&
        !invoice &&
        !project
      ) {
        console.log("CLOSING");
        return (this.searchPrompt = false);
      }

      let accountName = (account && account.name) || "";
      let productName = (product && product.label) || "";

      let baseUrls = [
        "/accounts/get?where=used",
        "/accounts/get?where=ordered",
        "/accounts/get?where=paid",
        "/accounts/get?where=unpaids",
      ];
      let baseUrl = baseUrls[tab];
      let w = 0;
      let filterQuery = { _where: [] };
      let query = "";

      if (product && product.value) {
        let id = product.value;
        query += `_where[${w}][product]=${id}&`;
        filterQuery._where.push({ product: id });
        w++;
      }
      if (account && account.id) {
        let id = account.id;
        query += `_where[${w}][account]=${id}&`;
        filterQuery._where.push({ account: id });
        w++;
      }

      if (invoice.trim()) {
        let wh = "ticketOrder.uid_contains";
        if (tab === 1 || tab === 3) wh = "uid_contains";
        query += `_where[${w}][${wh}]=${invoice}&`;
        filterQuery._where.push({ [wh]: invoice });
        w++;
      }
      if (project.trim()) {
        let wh = "projects.uid_contains";
        query += `_where[${w}][${wh}]=${project}&`;
        filterQuery._where.push({ [wh]: project });
        w++;
      }
      let dayFrom = "";
      let dayTo = "";

      if (dateFrom) {
        dayFrom = formatDate(dateFrom.getTime());
        let date = new Date(dayFrom);
        date = date.toISOString();
        let wh = "createdAt_gte";
        if (tab === 2) wh = "date_gte";
        query += `_where[${w}][${wh}]=${date}&`;
        filterQuery._where.push({ [wh]: date });
        w++;
      }
      if (dateTo) {
        dayTo = formatDate(dateTo.getTime());
        let date = new Date(dayTo);
        date = date.toISOString();
        let wh = "createdAt_lte";
        if (tab === 2) wh = "date_lte";
        query += `_where[${w}][${wh}]=${date}&`;
        filterQuery._where.push({ [wh]: date });
        w++;
      }

      let url = `${baseUrl}${
        baseUrl.includes("?") ? `&${query}` : `?${query}`
      }`;
      console.log("filterQuery QUERYYYYYY", filterQuery);

      this.filterQuery = filterQuery;

      if (dateTo) dateTo = formatDate(dateTo.getTime());

      if (dateFrom) {
        console.log("DATEFROM", dateFrom);
        dateFrom = formatDate(dateFrom.getTime());
        console.log("DATEFROM", dateFrom);
      }
      console.log("what SERACH", accountName);

      let terms = ["termUsed", "termPurchased", "termPaid", "termUnpaids"];
      let where = terms[tab];

      this.$data[where] = JSON.parse(
        JSON.stringify({
          account: accountName,
          dateTo: dayTo,
          dateFrom: dayFrom,
          product: productName,
          invoice,
          url,
        })
      );
      console.log("TERM AFTER", this.$data[where].url);
      this.searchPrompt = false;
      if (+this.currentTab !== +tab) this.currentTab = +tab;
    },
    getTime,

    async doTr(url) {
      if (this.currentTab == 0 && !this.totalTransactions) {
        try {
          let { data } = await this.$get("accounts/get/count?where=used");
          this.totalTransactions = data;
          console.log(this.totalTransactions, "totallllllTransactions");
        } catch (err) {
          console.error("error", err);
          this.totalTransactions = 1;
        }
      }

      let { data } = await this.$get(url);

      this.transactions = data;
      console.log(url, "transactions urrllllll");
      console.log(this.transactions, "transactions");
    },
    async doFunds(url) {
      console.log(url, "urrrllslsl");
      if (this.currentTab == 1) {
        try {
          let { data } = await this.$get("accounts/get/count?where=ordered");
          console.log(data);
          this.totalFunds = data;
        } catch (err) {
          this.totalFunds = 1;
        }
      }

      let { data } = await this.$get(url);
      this.allFunds = data;
    },

    async doUnpaids(url) {
      if (this.currentTab == 3) {
        let { data } = await this.$get("accounts/get/count?where=unpaids");
        this.totalFunds = data;
      }

      let { data } = await this.$get(url);

      this.allUnpaids = data;
    },
    async doPayments(url) {
      if (this.currentTab == 2) {
        try {
          let { data } = await this.$get("accounts/get/count?where=paid");
          this.totalPayments = data;
        } catch (err) {
          this.totalPayments = 1;
        }
      }

      let { data } = await this.$get(url);

      this.allPayments = data;
    },

    async doUnused() {
      try {
        let { data } = await this.$get("accounts/me/unusedTickets");
        console.log(data, "unusedOrder 1274");
        let allOrders = data;
        let ticketUnused = [];
        allOrders.forEach((order) => {
          // order items have
          if (order.ticketsUsed.length > 0) {
            for (let i = 0; i < order.orderItems.length; i++) {
              ticketUnused.push(orderItem[i]);
            }
          } else {
            for (let i = 0; i < order.orderItems.length; i++) {
              ticketUnused.push(orderItem[i]);
            }
          }
        });
      } catch (err) {
        console.error("error", err);
        // this.totalTransactions = 1;
      }
    },
    formatNumber(num) {
      if (!num) num = 0;
      return num.toLocaleString("US");
    },
    showTransaction(tr) {
      this.addNewDataSidebar = true;
      this.transaction = tr;
    },
    getOrderStatusColor(status) {
      if (status == "on hold") return "warning";
      if (status == "delivered") return "success";
      if (status == "canceled") return "danger";
      return "primary";
    },
    getPopularityColor(num) {
      if (num > 90) return "success";
      if (num > 70) return "primary";
      if (num >= 50) return "warning";
      if (num < 50) return "danger";
      return "primary";
    },
    formatData(data) {
      // formats data received from API
      let formattedData = data.map((item) => {
        const fields = item.fields;
        let obj = {};
        for (const key of Object.keys(fields)) {
          obj[key] =
            Number(fields[key].integerValue) ||
            Number(fields[key].doubleValue) ||
            fields[key].stringValue;
        }
        return obj;
      });
      return formattedData;
    },
  },
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
